import { Box } from "@material-ui/core"
import type { ErrorInfo, ReactNode } from "react"
import { Component } from "react"
import { withTranslation } from "react-i18next"
import type { TFunction } from "react-i18next"
import { Body1, Header4 } from ".."

export type ErrorDescription = {
  error: Error | null
  errorInfo: ErrorInfo | null
  hasError: boolean
}

export interface IErrorBoundryProps {
  children?: ReactNode
  clear?: boolean
  resetClear?: () => void
  t: TFunction
}

class ErrorBoundaryWithoutTranslation extends Component<IErrorBoundryProps, ErrorDescription> {
  public constructor(props: IErrorBoundryProps) {
    super(props)
    this.state = { error: null, errorInfo: null, hasError: false }
  }

  public static getDerivedStateFromError() {
    return { hasError: true }
  }

  public componentDidUpdate(prevProps: IErrorBoundryProps) {
    if (!prevProps.clear && this.props.clear) {
      this.clearError()
      if (this.props.resetClear) this.props.resetClear()
    }
  }
  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo
    })
  }

  public clearError(): void {
    this.setState({ hasError: false })
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: "1.6rem" }}>
          <Box display="flex" marginBottom="1.6rem">
            <Header4>{`${this.props.t("loadingError")} `}</Header4>
          </Box>
          <Body1>
            {this.state.error?.toString()}
            <br />
            {this.state.errorInfo?.componentStack}
          </Body1>
        </div>
      )
    }
    return this.props.children
  }
}

export const ErrorBoundary = withTranslation("map")(ErrorBoundaryWithoutTranslation)
